<template>
  <div>
    <div class="py-5 px-4 b-contract__payment-panel">
      <div class="row col-12">
        <div class="col-12 b-form__container_type_flex">
          <div class="col-11 px-0 b-form__container_type_flex b-form__row_type_flex-end">
            <div class="col-5 pl-0">
              <div data-cy="payment-kind">
                <label>{{$t('CONTENT.payments.payment_name_creation')}}:<span class="b-form__required"> *</span></label>
                <cool-select :list="paymentsName"
                             option-value="idInDB"
                             option-text="name"
                             :placeholder="$t('CONTENT.choose')"
                             :isError="isFieldWithError('currentPayment', currentPayment)"
                             v-model="currentPayment"/>
              </div>
            </div>
            <div class="col-1">
              <button
                type="button"
                data-cy="create-new-asset"
                class="b-btn b-btn_type_add"
                @click="openPaymentCreateDialog">
                <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="plus"></dynamic-icon>
              </button>
            </div>
            <div class="px-0 col-2">
              <div class="b-form__container">
                <label :for="`externalId-${assetComponentIndex}-${paymentIndex}`">{{ $t("CONTENT.external_id") }}:</label>
                <input
                  data-cy="externalId"
                  type="text"
                  :id="`externalId-${assetComponentIndex}-${paymentIndex}`"
                  class="b-input"
                  name="externalId"
                  v-model="externalId"/>
              </div>
            </div>
          </div>
          <div class="col-1">
            <div class="b-contract__payment-panel-btn" v-if="lessorComponentShares.paymentsParameters.length > 1">
              <button type="button" class="b-btn b-btn_border_none" @click="deletePayment">
                <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="delete"></dynamic-icon>
              </button>
            </div>
          </div>
        </div>
        <div v-if="isPaymentChoose" class="col-12 mt-5">
          <div class="row">
            <div class="col-3">
              <div class="b-form__container" data-cy="asset-type">
                <label>{{$t('CONTENT.payments.payment_type_creation')}}:</label>
                {{paymentType}}
              </div>
            </div>
            <div class="col-3" v-if="paymentKind !== null">
              <div class="b-form__container">
                <label>{{$t('CONTENT.payments.payment_kind_creation')}}:</label>
                {{paymentKind}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="b-contract__section-inner p-6 pt-0 pb-8">
      <div>
        <div class="col-2 p-0">
          <div>
            <label>{{$t('CONTENT.payments.payment_currency_code')}}:<span class="b-form__required"> *</span></label>
            <cool-select :list="allCurrencyCode"
                         option-value="code"
                         option-text="name"
                         :placeholder="$t('CONTENT.choose')"
                         :isError="isFieldWithError('currentCurrencyCode', currentCurrencyCode)"
                         v-model="currentCurrencyCode"/>
          </div>
        </div>
        <template v-if="isAddCurrencyCode">
          <CurrencyRateParametersWidget
            v-show="isAddCurrencyCode && currentCurrencyCode !== getContractSettings.currencyCode.toLowerCase()"
            :lessorComponentSharesIndex="lessorComponentSharesIndex"
            :assetComponentIndex="assetComponentIndex"
            :assetComponent="assetComponent"
            :paymentIndex="paymentIndex"
            :currencyCode="payment.currencyCode"
            :validationErrors="validationErrors"
            :importedCourseNames="importedCourseNames"
            :payment="payment"/>
        </template>
      </div>
      <div class="mt-5">
        <h4>{{$t('CONTENT.discountRates.rate')}}</h4>
        <div class="row mt-2 b-form__container_type_flex b-form__row_type_flex-end">
          <div class="col-2" data-cy="payment-lease-rate">
            <label>{{$t('CONTENT.payments.payment_lease_rate')}}:<span class="b-form__required"> *</span></label>
            <numeric
              class="b-numeric"
              :class="{ 'b-numeric__error': isFieldWithError('leaseRate', leaseRate) }"
              controls
              :min="0"
              :max="1000000000000"
              v-model="leaseRate"/>
          </div>
          <div class="col-2">
            <label>{{$t('CONTENT.payments.payment_units')}}:<span class="b-form__required"> *</span></label>
            <input
              data-cy="paymentUnitOfMeasure"
              type="text"
              :id="`paymentUnitOfMeasure-${assetComponentIndex}-${paymentIndex}`"
              class="b-input"
              name="paymentUnitOfMeasure"
              disabled
              :class="{
                'b-form__field-error': isFieldWithError('assetComponentUnitOfMeasure', assetComponentUnitOfMeasure)
              }"
              v-model="assetComponentUnitOfMeasure"/>
          </div>
          <div class="col-2">
            <label>{{ $t("CONTENT.payments.payment_lease_frequency") }}:<span class="b-form__required"> *</span></label>
            <cool-select
              :list="ratePeriods"
              option-value="value"
              option-text="text"
              :placeholder="$t('CONTENT.choose')"
              :isError="isFieldWithError('paymentLeaseFrequency', paymentLeaseFrequency)"
              :is-disabled="paymentFrequencyOnlyOnce()"
              v-model="paymentLeaseFrequency"/>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-5 mb-2 b-form__container_type_flex">
          <checkbox class="b-checkbox b-from__checkbox_pointer-event_none"
                    :id="`isSimplified${assetComponentIndex}-${paymentIndex}`" v-model="isSimplified">
            {{$t('CONTENT.payments.is_simplified')}}
          </checkbox>
<!--          <dynamic-icon class="ml-1" v-tooltip="$t('CONTENT.hints.default_hint')" icon="question"></dynamic-icon>-->
        </div>
      </div>
      <div class="row mt-5 b-form__container_type_flex b-form__row_type_flex-end">
        <div class="col-2">
          <div>
            <label class="b-form__container_type_flex">{{$t('CONTENT.payments.payment_date')}}:<span
              class="b-form__required"> *</span>
              <dynamic-icon class="ml-1" v-tooltip="$t('CONTENT.hints.paymentDateHint')" icon="question"/>
            </label>
            <datepicker
              v-bind:class="{ 'b-datepicker__error': isFieldWithError('startDate', startDate) }"
              class="b-datepicker"
              v-model="startDate"
              :formatter="datepickerFormat"
              :disabled-date="maxDateForStartDateFn"/>
          </div>
        </div>
        <div class="col-2">
          <div>
            <datepicker
              v-bind:class="{ 'b-datepicker__error': isFieldWithError('endDate', endDate) }"
              class="b-datepicker"
              v-model="endDate"
              :formatter="datepickerFormat"
              :disabled-date="minDateForEndDateFn"/>
          </div>
        </div>
        <div class="col-2">
          <div>
            <label>{{$t('CONTENT.payments.payment_first_date')}}:<span class="b-form__required"> *</span></label>
            <datepicker
              v-bind:class="{ 'b-datepicker__error': isFieldWithError('firstPaymentDate', firstPaymentDate) }"
              class="b-datepicker"
              v-model="firstPaymentDate"
              :formatter="datepickerFormat"
              :disabled="isLastPeriodDate"/>
          </div>
        </div>
        <div class="col-2">
          <label>{{$t('CONTENT.payments.payment_frequency')}}:<span class="b-form__required"> *</span></label>
          <cool-select :list="periods"
                       option-value="value"
                       option-text="text"
                       :placeholder="$t('CONTENT.choose')"
                       :isError="isFieldWithError('paymentPaymentFrequency', paymentPaymentFrequency)"
                       :is-disabled="paymentFrequencyOnlyOnce()"
                       v-model="paymentPaymentFrequency"/>
        </div>
        <div class="col-2">
          <checkbox class="b-checkbox" :id="`isLastPeriodDate${paymentIndex}`"
            v-model="isLastPeriodDate">{{$t('CONTENT.payments.is_last_period_date')}}</checkbox>
        </div>
      </div>
        <IndexationParametersWidget
          :lessorComponentSharesIndex="lessorComponentSharesIndex"
          :payment="payment"
          :paymentIndex="paymentIndex"
          :assetComponentIndex="assetComponentIndex"
          :paymentsName="paymentsName"
          :validationErrors="validationErrors"
          @changeIndexation="onChangeData"/>
        <DiscountParametersWidget
          :lessorComponentSharesIndex="lessorComponentSharesIndex"
          :payment="payment"
          :paymentIndex="paymentIndex"
          :assetComponentIndex="assetComponentIndex"
          @changeDiscount="onChangeData"
          :validationErrors="validationErrors"/>
    </div>
    <popup :name="`payment-popup-${paymentIndex}`" height="auto" :scrollable="true">
      <div data-cy="form-label" class="b-dialog__top-panel">
        <h2>{{$t('CONTENT.payments.payment_create')}}</h2>
        <button class="b-btn b-btn_border_none" @click.prevent="closePaymentCreateDialog">
          <dynamic-icon icon="close"/>
        </button>
      </div>
      <CreatePayment
        v-if="ifPaymentCreateModal"
        @closeDialog="closePaymentCreateDialog"
        @createPayment="onCreatePaymentName($event)"/>
    </popup>
  </div>
</template>

<script>
  import dateConverter from "../../../utils/converters/date.converter";
  import CreatePayment from "../../../components/registry/contracts/create/payments/CreatePayment";
  import datepickerFormat from '@/mixins/datepickerFormat.mixin';
  import PaymentParameters from "../models/PaymentParameters";
  import {mapGetters} from "vuex";

  export default {
    components: {
      CreatePayment,
    },
    mixins: [datepickerFormat],
    props: {
      lessorComponentShares: {
        type: Object,
        required: true,
      },
      lessorComponentSharesIndex: {
        type: Number,
        required: true,
      },
      assetComponent: {
        type: Object,
        required: true,
      },
      currencyCodes: {
        type: Array,
        required: true,
      },
      payment: {
        type: Object
      },
      paymentIndex: {
        type: Number
      },
      assetComponentIndex: {
        type: Number
      },
      paymentsName: {
        type: Array,
        required: true,
      },
      periods: {
        type: Array,
        required: true,
      },
      ratePeriods: {
        type: Array,
        required: true,
      },
      importedCourseNames: {
        type: Array,
      },
      validationErrors: {
        type: Array
      }
    },
    data() {
      return {
        paymentType: null,
        paymentKind: null,
        isPaymentChoose: false,
        isSimplified: true,
        ifPaymentCreateModal: false,
        maxDateForStartDate: null,
        minDateForEndDate: null,
        currencyCode: null,
      }
    },
    computed: {
      ...mapGetters(["getContractSettings"]),
      isAddCurrencyCode() {
        if (this.payment.currencyCode !== null) {
          return true;
        }
      },
      allCurrencyCode() {
        return this.currencyCodes;
      },
      currentCurrencyCode: {
        get() {
          if (this.payment.currencyCode !== null) {
            return this.payment.currencyCode.toLowerCase ();
          } else {
            return null;
          }
        },
        set(newVal) {
          this.$store.commit ('assetComponentsPlugin/updatePayment', {
            name: 'currencyCode',
            value: newVal.toUpperCase (),
            payment: this.payment,
            lessorComponentSharesIndex: this.lessorComponentSharesIndex,
          });
          this.onChangeData ();
        }
      },
      currentPayment: {
        get() {
          return this.payment.paymentNameId;
        },
        set(newVal) {
          this.setPaymentNameId(newVal);
        }
      },
      paymentLeaseFrequency: {
        get() {
          return this.payment.leaseFrequency;
        },
        set(newVal) {
          this.$store.commit ('assetComponentsPlugin/updatePayment', {
            name: 'leaseFrequency',
            value: newVal,
            payment: this.payment,
            lessorComponentSharesIndex: this.lessorComponentSharesIndex,
          });
          this.onChangeData ();
        }
      },
      paymentPaymentFrequency: {
        get() {
          return this.payment.paymentFrequency;
        },
        set(newVal) {
          this.$store.commit ('assetComponentsPlugin/updatePayment', {
            name: 'paymentFrequency',
            value: newVal,
            payment: this.payment,
            lessorComponentSharesIndex: this.lessorComponentSharesIndex,
          });
          this.onChangeData ();
        }
      },
      externalId: {
        get() {
          return this.payment.externalId;
        },
        set(newVal) {
          this.$store.commit ('assetComponentsPlugin/updatePayment', {
            name: 'externalId',
            value: newVal,
            payment: this.payment,
            lessorComponentSharesIndex: this.lessorComponentSharesIndex,
          });
          this.onChangeData ();
        }
      },
      leaseRate: {
        get() {
          if (this.payment.leaseRate !== null) {
            return this.payment.leaseRate;
          }
        },
        set(newVal) {
          this.$store.commit ('assetComponentsPlugin/updatePayment', {
            name: 'leaseRate',
            value: newVal,
            payment: this.payment,
            lessorComponentSharesIndex: this.lessorComponentSharesIndex,
          });
          this.onChangeData ();
        }
      },
      assetComponentUnitOfMeasure() {
        let unitOfMeasure = this.assetComponent.unitOfMeasureCode;
        if (unitOfMeasure === null) {
          return null;
        } else {
          return this.$t ('CONTENT.' + unitOfMeasure);
        }
      },
      startDate: {
        get() {
          if (this.payment.startDate === null && this.assetComponent.startDate !== null) {
            this.payment.startDate = this.assetComponent.startDate;
            this.$store.commit ('assetComponentsPlugin/updatePayment', {
              name: 'startDate',
              value: this.assetComponent.startDate,
              payment: this.payment,
              lessorComponentSharesIndex: this.lessorComponentSharesIndex,
            });
            return dateConverter.convertToDate (this.payment.startDate);
          } else {
            return dateConverter.convertToDate (this.payment.startDate);
          }
        },
        set(newVal) {
          if (newVal !== null) {
            let startDateObject = newVal;
            this.minDateForEndDate = newVal;
            this.minDateForEndDateFn ();
            let startDate = dateConverter.convertToString (startDateObject);

            this.$store.commit ("assetComponentsPlugin/updatePayment", {
              name: "startDate",
              value: startDate,
              payment: this.payment,
              lessorComponentSharesIndex: this.lessorComponentSharesIndex,
            });
          } else {
            this.payment.startDate = null;
          }
          this.onChangeData ();
        }
      },
      endDate: {
        get() {
          if (this.payment.endDate !== null)
            return dateConverter.convertToDate(this.payment.endDate)

          const endDate = this.actualAssetEndDate(this.assetComponent)
          this.payment.endDate = endDate

          this.$store.commit ("assetComponentsPlugin/updatePayment", {
            name: "endDate",
            value: endDate,
            payment: this.payment,
            lessorComponentSharesIndex: this.lessorComponentSharesIndex,
          })

          return dateConverter.convertToDate(endDate)
        },
        set(newVal) {
          if (newVal !== null) {
            let endDateObject = newVal;
            this.maxDateForStartDate = newVal;
            this.maxDateForStartDateFn();
            const endDate = dateConverter.convertToString(endDateObject);

            this.$store.commit ("assetComponentsPlugin/updatePayment", {
              name: "endDate",
              value: endDate,
              payment: this.payment,
              lessorComponentSharesIndex: this.lessorComponentSharesIndex,
            });
          } else {
            this.payment.endDate = null;
          }
          this.onChangeData ();
        }
      },
      firstPaymentDate: {
        get() {
          if (this.payment.firstPaymentDate === null) {
            return null;
          } else {
            return dateConverter.convertToDate (this.payment.firstPaymentDate);
          }
        },
        set(newVal) {
          if (newVal !== null) {
            let firstPaymentDate = dateConverter.convertToString (newVal);

            this.$store.commit ('assetComponentsPlugin/updatePayment', {
              name: 'firstPaymentDate',
              value: firstPaymentDate,
              payment: this.payment,
              lessorComponentSharesIndex: this.lessorComponentSharesIndex,
            });
          } else {
            this.payment.firstPaymentDate = null;
          }
          this.onChangeData ();
        }
      },
      isLastPeriodDate: {
        get(){
          if (this.payment.isLastPeriodDate !== null) {
            return this.payment.isLastPeriodDate;
          } else {
            return null;
          }
        },
        set(newVal){
          this.$store.commit('assetComponentsPlugin/updatePayment', {
            name: 'isLastPeriodDate',
            value: newVal,
            payment: this.payment,
            lessorComponentSharesIndex: this.lessorComponentSharesIndex,
          });

          if(this.payment.isLastPeriodDate) {
            let startDate = dateConverter.convertToDate(this.payment.startDate);

            if (this.payment.firstPaymentDate !== null)
              startDate = dateConverter.convertToDate(this.payment.firstPaymentDate);

            const lastDayOfMonth = new Date(startDate.getFullYear(), startDate.getMonth()+1, 0);
            this.$store.commit ('assetComponentsPlugin/updatePayment', {
              name: 'firstPaymentDate',
              value: dateConverter.convertToString (lastDayOfMonth),
              payment: this.payment,
              lessorComponentSharesIndex: this.lessorComponentSharesIndex,
            });
          }

          this.onChangeData ();
        }
      }
    },
    watch: {
      assetComponent: {
        handler() {
          this.$store.commit ('assetComponentsPlugin/updateLessorComponentShare', {
            name: 'startDate',
            value: this.assetComponent.startDate,
            lessor: this.lessorComponentShares,
          });

          this.$store.commit ('assetComponentsPlugin/updateLessorComponentShare', {
            name: 'endDate',
            value: this.actualAssetEndDate(this.assetComponent),
            lessor: this.lessorComponentShares,
          });
        },
        deep: true
      },
    },
    mounted() {
      this.$store.commit ('assetComponentsPlugin/updateLessorComponentShare', {
        name: 'startDate',
        value: this.assetComponent.startDate,
        lessor: this.lessorComponentShares,
      });

      this.$store.commit ('assetComponentsPlugin/updateLessorComponentShare', {
        name: 'endDate',
        value: this.actualAssetEndDate(this.assetComponent),
        lessor: this.lessorComponentShares,
      });
    },
    methods: {
      actualAssetEndDate(assetComponent) {
        if (assetComponent.extension != null && assetComponent.extension.date != null)
          return assetComponent.extension.date
        if (assetComponent.termination != null && assetComponent.termination.date != null)
          return assetComponent.termination.date
        return assetComponent.endDate
      },
      maxDateForStartDateFn(date) {
        if (this.maxDateForStartDate !== null) {
          return date > this.maxDateForStartDate;
        }
      },
      minDateForEndDateFn(date) {
        if (this.minDateForEndDate !== null) {
          return date < this.minDateForEndDate;
        }
      },
      deletePayment() {
        this.$store.commit ('assetComponentsPlugin/deletePayment', {
          payment: this.payment,
          lessorComponentSharesIndex: this.lessorComponentSharesIndex,
        });
        this.onChangeData ();
      },
      setPaymentNameId(value) {
        this.$store.commit ('assetComponentsPlugin/updatePaymentByIdInDb', {
          value: value,
          paymentIdInDb: this.payment.idInDB,
          lessorComponentSharesIndex: this.lessorComponentSharesIndex,
        });
        this.setCurrentPaymentInfo(value);
        this.onChangeData();
      },
      setCurrentPaymentInfo(id) {
        const neededPayment = this.paymentsName.find(p => p.idInDB === id);

        if (neededPayment) {
          this.paymentType = this.$t("CONTENT.payments." + neededPayment.paymentTypeCode);
          if(neededPayment.paymentKindCode !== null) {
            this.paymentKind = this.$t("CONTENT.payments." + neededPayment.paymentKindCode);
          } else this.paymentKind = null
        }

        if (this.paymentFrequencyOnlyOnce()) {
          this.payment.leaseFrequency = 'Once'
          this.payment.paymentFrequency = 'Once'
        }

        this.isPaymentChoose = true;
      },
      paymentFrequencyOnlyOnce() {
        const payment = this.paymentsName.find(p => p.idInDB === this.payment.paymentNameId)
        if (payment === undefined) return false
        if (payment.paymentTypeCode === 'fixed_lease_payment' && payment.paymentKindCode === 'upfront_payment') return true
        if (payment.paymentTypeCode === 'not_lease_payment' && payment.paymentKindCode === 'guarantee_payment_returnable') return true
        if (payment.paymentTypeCode === 'residual_value_guarantees' && payment.paymentKindCode === null) return true
        if (payment.paymentTypeCode === 'variable_lease_payment_depend_on_index' && payment.paymentKindCode === 'guarantee_payment_accountable') return true
        if (payment.paymentTypeCode === 'purchase_option' && payment.paymentKindCode === null) return true
        if (payment.paymentTypeCode === 'penalty_payment' && payment.paymentKindCode === null) return true
        return false
      },
      onCreatePaymentName(newPaymentName) {
        this.setPaymentNameId (newPaymentName.idInDB);
        this.onChangeData();
      },
      onChangeData() {
        this.$emit ("changePaymentData");
      },
      openPaymentCreateDialog() {
        this.ifPaymentCreateModal = true;
        this.$modal.show (`payment-popup-${this.paymentIndex}`);
      },
      closePaymentCreateDialog() {
        this.ifPaymentCreateModal = false;
        this.$modal.hide (`payment-popup-${this.paymentIndex}`);
      },
      isFieldWithError(field, value) {
        if(!this.validationErrors || !this.validationErrors[this.payment.validationIndex]) {
          return;
        }

        return !value && this.validationErrors && this.validationErrors[this.payment.validationIndex].includes (field);
      },
    }
  };
</script>
